import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import HourField from '../../../shared/components/form/HourField';
import ShiftItemsGrid from './ShiftItemsGrid';

const ShiftForm = (props) => {
  const { t, backHandler, handleSubmit, dto, initialize, dispatch } = props;

  const [formValues, setFormValues] = useState({});

  const changeFormValues = (field, value) => {
    const updatedFormValue = { ...formValues };
    updatedFormValue[field] = value;
    setFormValues(updatedFormValue);
  };

  useEffect(() => {
    initialize(dto);
    setFormValues({ ...dto });
  }, [dto]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.name')}</span>
        <div className="form__form-group-field">
          <Field
            name="name"
            type="text"
            component={renderField}
            maxLength="50"
            placeholder={t('placeholder.shift.name')}
          />
        </div>
      </div>
      <div className="form__form-group--5_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.start_time')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="startTime"
              type="text"
              component={HourField}
              maxLength="4"
              placeholder={t('placeholder.hour')}
              onChange={({ target }) =>
                changeFormValues('startTime', target.value)
              }
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.end_time')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="finalTime"
              type="text"
              component={HourField}
              maxLength="4"
              placeholder={t('placeholder.hour')}
              onChange={({ target }) =>
                changeFormValues('finalTime', target.value)
              }
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('placeholder.shift.consolidationDiaryHour')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="consolidationTime"
              type="text"
              component={HourField}
              maxLength="4"
              placeholder={t('placeholder.shift.consolidationDiaryHour')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.classes')}</span>
          <div className="form__form-group-field">
            <Field
              name="classQuantity"
              type="number"
              component={renderField}
              maxLength="3"
              min="1"
              placeholder={t('placeholder.shift.classes')}
              onChange={({ target }) =>
                changeFormValues('classQuantity', target.value)
              }
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.intervals')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="intervalQuantity"
              type="number"
              component={renderField}
              maxLength="3"
              min="0"
              placeholder={t('placeholder.shift.intervals')}
              onChange={({ target }) =>
                changeFormValues('intervalQuantity', target.value)
              }
            />
          </div>
        </div>
      </div>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <ShiftItemsGrid
            dto={dto}
            formValues={formValues}
            dispatch={dispatch}
          />
        </div>
      </div>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <Label className="generic__label"> {t('general.active')} </Label>
          <Field
            name="active"
            component={renderCheckBoxField}
            className="colored-click"
          />
        </div>
      </div>
      <ButtonToolbar className="form__button-toolbar">
        <Button color="primary" onClick={backHandler}>
          {t('general.back')}
        </Button>
        <Button color="success" type="submit">
          {t('general.save')}
        </Button>
      </ButtonToolbar>
    </form>
  );
};

ShiftForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'ShiftForm',
  validate,
})(withTranslation('common')(ShiftForm));
